<template>
  <a-select
    :value="value"
    :show-search="showSearch"
    :allow-clear="allowClear"
    :mode="mode || undefined"
    :placeholder="placeholder"
    :disabled="disabled"
    option-filter-prop="title"
    @change="onChange"
    :class="class"
  >
    <a-select-option
      v-for="item in options"
      :key="item.valCode"
      :value="item[valCode]"
      :title="item.valName"
      :disabled="disableArray.includes(item.valCode)"
    >
      {{ item.valName }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref, watch } from "vue";
import { DictValRecord } from "@/views/system/dict/dict.interface";
import { DictService } from "@/views/system/dict/dict.service";

type IValue = string[] | string | undefined;
type ISelectMode = undefined | "" | "multiple" | "tags" | "combobox";

/**
 * 全局组件: 字段选择器
 *
 * 使用方式:
 * <dict-select v-model="formRef.dictCode" code="sex"></dict-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "DictSelect",
  props: {
    code: {
      type: String,
      required: true,
    },
    valCode:{
      type: String,
      default: "valCode",
    },
    value: {
      type: [Array, String] as PropType<IValue>,
      default: undefined,
    },
    mode: {
      type: String as PropType<ISelectMode>,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableArray: {
      type: Array,
      default: () => [],
    },
    class: {
      type: String,
      default: "append-to-body",
    },
    list: {
      type: Array,
      default:()=>[],
    },
  },
  emits: ["update:value", "change","update:list"],
  setup(props, { emit }) {
    const options = ref<DictValRecord[]>([]);

    const onChange = (code) => {
      emit("update:value", code);
      emit("change", code);
    };
    watch(
      () => props.code,
      async (n, o) => {
        if (n) {
          options.value = await DictService.fetchOptionsByDictCode(props.code);
          emit("change", n);
          emit("update:list",options.value)
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    return {
      options,
      onChange,
    };
  },
});
</script>
